module.exports = __webpack_public_path__ + "img/logo22.0660436c.png";